export const initializeGoogleAnalytics = () => {
  if (!process.env.REACT_APP_GTM_ID) return;

  const headEl = document.getElementsByTagName('head')[0];

  // GTM script
  const gtmScript = document.createElement('script');
  gtmScript.async = true;
  gtmScript.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${process.env.REACT_APP_GTM_ID}');
  `;
  headEl.appendChild(gtmScript);

  // GTM noscript iframe
  const gtmNoscript = document.createElement('noscript');
  const gtmIframe = document.createElement('iframe');
  gtmIframe.src = `https://www.googletagmanager.com/ns.html?id=${process.env.REACT_APP_GTM_ID}`;
  gtmIframe.height = '0';
  gtmIframe.width = '0';
  gtmIframe.style.display = 'none';
  gtmIframe.style.visibility = 'hidden';
  gtmNoscript.appendChild(gtmIframe);
  document.body.insertBefore(gtmNoscript, document.body.firstChild);
};